let hostname = window.location.hostname;
let appBaseUrl, redirectUri, oktaCustomTenantUrl;
if (hostname.includes("local") || hostname.includes("test")) {
  appBaseUrl = "https://secure-test.freedomconnect.com/";
  oktaCustomTenantUrl = "https://identitytest.freedomconnect.com/";
  // oktaTenantUrl = "https://freedomcorrespondent.oktapreview.com/";
  redirectUri =
    oktaCustomTenantUrl +
    "home/freedomcorrespondent_samltest_1/0oadhntq8d1kIgIiv1d7/alndhphy2kwjzfDDZ1d7";
} else if (hostname.includes("dev")) {
  appBaseUrl = "https://secure-dev.freedomconnect.com/";
  oktaCustomTenantUrl = "https://identitydev.freedomconnect.com/";
  // oktaTenantUrl = "https://freedomcorrespondent.oktapreview.com/";
  redirectUri =
    oktaCustomTenantUrl +
    "home/freedomcorrespondent_corrsamldev_1/0oacuyfru2vXG3BQm1d7/alncuyo8hqSXNLMRP1d7";
} else if (hostname.includes("uat")) {
  appBaseUrl = "https://secure-uat.freedomconnect.com/";
  oktaCustomTenantUrl = "https://identityuat.freedomconnect.com/";
  // oktaTenantUrl = "https://freedomcorrespondent.oktapreview.com/";
  redirectUri =
    oktaCustomTenantUrl +
    "home/freedomcorrespondent_samluat_1/0oadlavq7nHM795fw1d7/alndlb9tkuBr4bdcQ1d7";
} else {
  appBaseUrl = "https://secure.freedomconnect.com/";
  oktaCustomTenantUrl = "https://identity.freedomconnect.com/";
  // oktaTenantUrl = "https://freedomcorrespondent.okta.com/";
  redirectUri =
    oktaCustomTenantUrl +
    "home/freedomcorrespondent_samlprod_1/0oa1pfcw5ljhjBTtU1d8/aln1pfcybx1e1ghYJ1d8";
}

const config = {
  appBaseUrl: appBaseUrl,
  widget: {
    issuer: oktaCustomTenantUrl + "oauth2/default",
    scopes: ["profile", "email"],
    redirectUri: redirectUri,
    useClassicEngine: true,
    features: {
      showPasswordToggleOnSignInPage: true,
      hideSignOutLinkInMFA: false,
      rememberMe: false,
    },
    i18n: {
      en: {
        "password.forgot.email.or.username.placeholder": "User ID",
        "password.forgot.email.or.username.tooltip": "User ID",
        "account.unlock.email.or.username.placeholder": "User ID",
        "account.unlock.email.or.username.tooltip": "User ID",
        "primaryauth.username.placeholder": "User ID",
        "primaryauth.username.tooltip": "User ID",
        "primaryauth.submit": "LOGIN",
        "oie.enroll.switch.authenticator": " ",
        "errors.E0000004": "Username or password is incorrect. Please try again. If the error persists, your account may have been locked or disabled. Please contact your Sales Associate for assistance.",
        "error.auth.lockedOut":
          "Your account is locked. Please check your email for instructions to unlock the account or contact your Sales Associate for assistance.",
      },
    },
  },
};

export default config;
